import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryforceurbaniaonrent() {



    const cardData = {

keyword: "Luxury Force Urbania On Rent in Pune",

headingDescription:
    "Rising Cab Service offers premium Luxury Force Urbania On Rent in Pune for corporate travel, weddings, airport transfers, family tours, and outstation group journeys. Our Force Urbania vehicles are equipped with luxury push-back seats, high roof comfort, premium interiors, air conditioning, ample luggage space, and experienced professional drivers. With doorstep pickup across Pune, flexible rental packages, 24/7 support, and transparent pricing, we ensure a stylish, comfortable, and high-end travel experience for large groups and VIP travel requirements.",

topPlaces: [
    {
        title: "Lonavala & Khandala Luxury Trip",
        description:
            "Lonavala and Khandala are premium weekend destinations near Pune known for lush green valleys, waterfalls, and scenic viewpoints. Luxury Force Urbania is ideal for family groups and corporate teams who want a comfortable and premium travel experience during monsoon drives and short luxury getaways."
    },
    {
        title: "Mahabaleshwar Luxury Tour",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, and cool climate. Traveling in Force Urbania adds premium comfort for large groups, making it perfect for luxury family vacations, corporate retreats, and sightseeing tours."
    },
    {
        title: "Goa Premium Beach Holiday",
        description:
            "Goa is a top luxury travel destination from Pune known for beaches, nightlife, and adventure sports. Force Urbania rental is ideal for VIP group travel, weddings, and premium vacation tours, ensuring maximum comfort during long-distance highway journeys."
    },
    {
        title: "Shirdi Sai Baba Luxury Darshan",
        description:
            "Shirdi is one of the most important pilgrimage destinations in India. Force Urbania provides premium group travel for Sai Baba darshan, offering smooth highway rides, spacious seating, and a comfortable spiritual journey for families and devotees."
    },
    {
        title: "Nashik Vineyard Luxury Tour",
        description:
            "Nashik is known for vineyards, temples, and Trimbakeshwar Jyotirlinga. Luxury Urbania travel is perfect for wine tours, corporate outings, and premium family trips exploring vineyards and spiritual destinations together."
    },
    {
        title: "Ashtavinayak Luxury Darshan",
        description:
            "The Ashtavinayak pilgrimage circuit includes eight sacred Ganpati temples across Maharashtra. Force Urbania is ideal for luxury group darshan tours, offering comfort, space, and a premium travel experience for devotees."
    },
    {
        title: "Alibaug Luxury Coastal Trip",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches and forts. Luxury Urbania rentals are perfect for premium group outings, beach vacations, and corporate leisure trips from Pune."
    },
    {
        title: "Konkan Luxury Coastal Drive",
        description:
            "The Konkan coast including Ganpatipule, Diveagar, and Tarkarli offers scenic beaches and greenery. Force Urbania ensures a smooth luxury journey for long-distance coastal tours with maximum comfort and space."
    },
    {
        title: "Aurangabad Heritage Luxury Tour",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, UNESCO World Heritage Sites. Luxury Urbania travel is ideal for premium cultural tours, educational trips, and family heritage journeys from Pune."
    },
    {
        title: "Pune Airport VIP Transfers",
        description:
            "Force Urbania is widely used for luxury airport transfers in Pune, offering premium pickup and drop services for corporate groups, weddings, and VIP guests with maximum comfort and convenience."
    }
],



services: [
{
name: "Luxury Force Urbania on Rent in Hadapsar",
description: "Rising Cab Service offers Luxury Force Urbania on Rent in Hadapsar for premium group travel experiences. Ideal for corporate tours, weddings, and family outings, our Urbania vehicles provide high-end comfort, push-back seats, spacious interiors, and smooth suspension. Enjoy professional chauffeurs, timely pickup, and safe outstation travel from Hadapsar to all major destinations."
},
{
name: "13 Seater Force Urbania on Rent in Pune",
description: "Book 13 Seater Force Urbania on Rent in Pune for medium group travel with luxury comfort. Perfect for airport transfers, family trips, and corporate travel, this vehicle offers AC comfort, modern interiors, ample luggage space, and a smooth ride experience with trained drivers."
},
{
name: "17 Seater Force Urbania on Rent in Pune",
description: "Our 17 Seater Force Urbania on Rent in Pune is ideal for large groups seeking premium travel. With spacious seating, advanced suspension, and luxury interiors, it ensures a comfortable journey for long-distance tours, weddings, and corporate outings across Maharashtra and beyond."
},
{
name: "Urbania Hire in Pune for Outstation",
description: "Rising Cab Service provides Urbania Hire in Pune for Outstation trips with reliable, comfortable, and safe long-distance travel options. Perfect for hill stations, religious tours, and business travel with professional drivers and flexible travel plans."
},
{
name: "Pune to Lonavala Urbania Bus on Rent",
description: "Book Pune to Lonavala Urbania Bus on Rent for a luxurious hill station trip. Enjoy scenic travel with premium seating, AC comfort, and experienced drivers ensuring a smooth journey to Lonavala and nearby attractions."
},
{
name: "Pune to 5 Jyotirlinga Darshan Urbania on Rent",
description: "Our Pune to 5 Jyotirlinga Darshan Urbania on Rent service is designed for spiritual group tours covering major Jyotirlinga temples. Travel comfortably with luxury seating, safe driving, and customized pilgrimage itineraries."
},
{
name: "Pune Darshan Urbania on Rent",
description: "Rising Cab Service offers Pune Darshan Urbania on Rent for city sightseeing tours in premium comfort. Explore Pune’s famous landmarks with spacious seating, AC vehicles, and flexible sightseeing stops."
},
{
name: "Pune to Nashik Urbania on Rent",
description: "Book Pune to Nashik Urbania on Rent for vineyard tours, religious visits, and family trips. Enjoy a smooth and luxurious ride with professional drivers and modern Urbania vehicles."
},
{
name: "Pune to Bhimashankar Urbania Bus Hire",
description: "Our Pune to Bhimashankar Urbania Bus Hire service provides safe and comfortable travel for temple visits and nature trips. Ideal for families and groups seeking a premium pilgrimage experience."
},
{
name: "Pune to Ajanta Ellora Urbania Bus Hire",
description: "Rising Cab Service offers Pune to Ajanta Ellora Urbania Bus Hire for heritage and sightseeing tours. Travel in luxury with spacious seating and experienced chauffeurs for a smooth journey to Ajanta and Ellora caves."
},
{
name: "Luxury Force Urbania on Rent in Pune Near Me",
description: "Get Luxury Force Urbania on Rent in Pune Near Me for premium group travel with doorstep pickup, professional drivers, and high-comfort interiors suitable for weddings, tours, and corporate trips."
},
{
name: "Luxury Force Urbania on Rent in Kothrud",
description: "Book Luxury Force Urbania on Rent in Kothrud for comfortable and premium group transportation. Ideal for family functions, airport transfers, and outstation trips with luxury seating and reliable service."
},
{
name: "Luxury Force Urbania on Rent in Pimpri Chinchwad",
description: "Rising Cab Service provides Luxury Force Urbania on Rent in Pimpri Chinchwad for corporate and family group travel. Enjoy spacious luxury interiors, AC comfort, and safe long-distance journeys."
},
{
name: "Luxury Force Urbania on Rent in Pune Contact Number",
description: "Contact Rising Cab Service for Luxury Force Urbania on Rent in Pune Contact Number to book instantly. We provide 24x7 support, easy booking options, and premium Urbania vehicles for all travel needs."
}
],

tableData: [
["Luxury Force Urbania on Rent in Hadapsar","13 Seater Force Urbania on Rent in Pune"],
["17 Seater Force Urbania on Rent in Pune","Urbania Hire in Pune for Outstation"],
["Pune to Lonavala Urbania Bus on Rent","Pune to 5 Jyotirlinga Darshan Urbania on Rent"],
["Pune Darshan Urbania on Rent","Pune to Nashik Urbania on Rent"],
["Pune to Bhimashankar Urbania Bus Hire","Pune to Ajanta Ellora Urbania Bus Hire"],
["Luxury Force Urbania on Rent in Pune Near Me","Luxury Force Urbania on Rent in Kothrud"],
["Luxury Force Urbania on Rent in Pimpri Chinchwad","Luxury Force Urbania on Rent in Pune Contact Number"]
],



whychoose: [
    {
        WhyChooseheading: "Premium Luxury Force Urbania on Rent in Pune",
        WhyChoosedescription: "Rising Cab Service offers luxury Force Urbania rental services in Pune for corporate travel, family vacations, weddings, airport transfers, pilgrimages, and luxury group tours."
    },
    {
        WhyChooseheading: "Modern Luxury Interior Experience",
        WhyChoosedescription: "Force Urbania features premium pushback seats, spacious interiors, superior legroom, elegant cabin design, and enhanced passenger comfort for long journeys."
    },
    {
        WhyChooseheading: "Perfect for Corporate and VIP Travel",
        WhyChoosedescription: "The Luxury Urbania is ideal for corporate events, executive transportation, destination weddings, business tours, celebrity travel, and premium guest transfers."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Tours",
        WhyChoosedescription: "Urbania rental services are available for Pune city travel and destinations such as Mahabaleshwar, Goa, Shirdi, Nashik, Mumbai, Konkan, Kolhapur, and other tourist locations."
    },
    {
        WhyChooseheading: "Spacious Seating with Premium Comfort",
        WhyChoosedescription: "The vehicle offers comfortable seating arrangements, large windows, excellent air circulation, luggage space, and a luxury travel experience."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Luxury Urbania pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Chauffeurs for Safe Travel",
        WhyChoosedescription: "Experienced drivers ensure smooth highway driving, safe transportation, punctual service, and a hassle-free journey."
    },
    {
        WhyChooseheading: "Best Choice for Family and Group Travel",
        WhyChoosedescription: "Luxury Force Urbania is widely preferred for family vacations, group tours, corporate outings, wedding functions, and long-distance travel."
    }
]
};

const faqData = [
    {
        question: "What is Luxury Force Urbania on Rent in Pune?",
        answer: "Luxury Force Urbania rental service provides a premium passenger vehicle with spacious seating and modern amenities for group travel."
    },
    {
        question: "How many passengers can travel in a Force Urbania?",
        answer: "Depending on the configuration, Force Urbania is available in multiple seating capacities suitable for family and group travel."
    },
    {
        question: "Can I hire a Luxury Urbania for outstation trips?",
        answer: "Yes, Luxury Force Urbania vehicles are available for outstation tours across Maharashtra and India."
    },
    {
        question: "Is Force Urbania suitable for corporate travel?",
        answer: "Yes, Urbania is one of the most preferred luxury vehicles for corporate transportation, executive travel, and business events."
    },
    {
        question: "Can Urbania be booked for wedding transportation?",
        answer: "Yes, Luxury Urbania is widely used for wedding guest transportation, destination weddings, and family functions."
    },
    {
        question: "Is Force Urbania comfortable for long-distance journeys?",
        answer: "Yes, the spacious cabin, comfortable seating, and premium interiors make it ideal for long-distance travel."
    },
    {
        question: "Can families hire Urbania for vacations and tours?",
        answer: "Yes, Urbania is an excellent choice for family holidays, sightseeing tours, and group vacations."
    },
    {
        question: "Do you provide Urbania for pilgrimage tours?",
        answer: "Yes, Urbania vehicles are available for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga, and other religious tours."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book Luxury Force Urbania on Rent in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Aditya Kulkarni",
        feedback:
            "We booked a Luxury Urbania for our Goa family trip. The seating comfort, premium interiors, and smooth ride made the journey exceptionally enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Rucha Deshmukh",
        feedback:
            "Our corporate team traveled in the Force Urbania for an outstation event. The vehicle was spacious, luxurious, and perfect for executive group travel.",
        rating: 5
    }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Luxury Force Urbania on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/force-urbania-pune.jpg",
"description": "Book Luxury Force Urbania on Rent in Pune with Rising Cab Service for premium group travel, weddings, corporate tours, and outstation trips. Available in 13 and 17 seater AC luxury vans for maximum comfort and style.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹28/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/luxury-force-urbania-on-rent-pune"
}
};









    return (
        <div>

<Helmet>
  <title>Luxury Force Urbania on Rent in Pune | Premium Group Travel Van | +91 9272511548</title>

<meta
 name="description"
 content="Book Luxury Force Urbania on Rent in Pune for premium group travel, weddings, corporate tours, and outstation trips. Available in 13 & 17 seater AC luxury vans for maximum comfort."
/>

<meta
 name="keywords"
 content="luxury force urbania on rent in pune, 13 seater force urbania pune, 17 seater force urbania pune, urbania hire in pune for outstation, pune to lonavala urbania, pune to nashik urbania, pune to bhimashankar urbania, pune to ajanta ellora urbania, urbania for 5 jyotirlinga darshan pune, luxury urbania rent hadapsar, luxury urbania rent kothrud, urbania bus hire pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Luxuryforceurbaniaonrent;